export default __webpack_public_path__ + "static/menu-do-light-56eef61071267d0158e1d3ec9d203a38.png";